import { FC } from 'react';
import { useWatch } from 'react-hook-form';

import { Grid } from '@mui/material';

import { FieldTableHeader } from 'components/_basic/Form/FieldTable2/components/FieldTableHeader';
import { FieldTableContainer } from 'components/_basic/Form/FieldTableContainer';
import { FormSectionFilledCard } from 'components/_basic/FormSectionFilledCard';
import {
  GLOBAL_PERIOD_NAME,
  GLOBAL_PERIOD_TABLE_HEADINGS_NAME,
} from 'components/BusinessToolForm/Sections/Global/form';

import { getPeriodColumnsNames } from 'helpers/businessTool';

import { IProfitAndLossProjectionFormBodyProps } from './types';
import { FIRST_COLUMN_WIDTH } from '../../utils/form';
import { NetIncomeForm } from '../FormSections/NetIncome';
import { NetSalesForm } from '../FormSections/NetSalesForm';
import { OperatingExpensesForm } from '../FormSections/OperatingExpensesForm';

import styles from './ProfitAndLossProjectionFormBody.module.scss';

export const ProfitAndLossProjectionFormBody: FC<IProfitAndLossProjectionFormBodyProps> = ({ disabled = false }) => {
  const period = useWatch({ name: GLOBAL_PERIOD_NAME });

  const columnsNames = getPeriodColumnsNames(period);

  return (
    <FormSectionFilledCard>
      <FieldTableContainer>
        <Grid item xs className={styles.stickyTop}>
          <FieldTableHeader
            name={GLOBAL_PERIOD_TABLE_HEADINGS_NAME}
            disabled={disabled}
            columnsNames={columnsNames || []}
            firstColumnWidth={FIRST_COLUMN_WIDTH}
            firstColumnClass={styles.sticky}
            editableColumn={true}
          />
        </Grid>
        <Grid container direction="column" gap={5}>
          <Grid item xs>
            <NetSalesForm disabled={disabled} />
          </Grid>
          <Grid item xs>
            <OperatingExpensesForm disabled={disabled} />
          </Grid>
          <Grid item xs>
            <NetIncomeForm disabled={disabled} />
          </Grid>
        </Grid>
      </FieldTableContainer>
    </FormSectionFilledCard>
  );
};
